import React, { useState, useEffect } from "react";
import { X, CheckCircle2 } from "lucide-react";

export default function RecurringModal({ task, onClose, onSave, onComplete }) {
  const [formData, setFormData] = useState({
    id: "", client: "", description: "", nextDueDate: "", frequency: "1M",
  });

  useEffect(() => {
    if (task) setFormData({ ...task });
    else setFormData({ id: "", client: "", description: "", nextDueDate: "", frequency: "1M" });
  }, [task]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 modal-backdrop" data-testid="recurring-modal">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 fade-in">
        <div className="flex justify-between items-center mb-5">
          <h3 className="text-xl font-outfit font-bold text-slate-900">
            {task ? "Gestione Scadenza" : "Nuova Scadenza Ciclica"}
          </h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-700">
            <X size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1">Oggetto *</label>
            <input
              required value={formData.client}
              onChange={(e) => setFormData({ ...formData, client: e.target.value })}
              className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
              data-testid="recurring-client-input"
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1">Descrizione *</label>
            <textarea
              required value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
              rows={3}
              data-testid="recurring-description-input"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1">Prossima Scadenza</label>
              <input
                type="date" required value={formData.nextDueDate}
                onChange={(e) => setFormData({ ...formData, nextDueDate: e.target.value })}
                className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                data-testid="recurring-nextDueDate-input"
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1">Frequenza</label>
              <select
                value={formData.frequency}
                onChange={(e) => setFormData({ ...formData, frequency: e.target.value })}
                className="w-full p-2.5 border border-slate-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                data-testid="recurring-frequency-select"
              >
                <option value="1M">Mensile</option>
                <option value="3M">Trimestrale</option>
                <option value="6M">Semestrale</option>
                <option value="1Y">Annuale</option>
                <option value="MANUAL">Data Specifica (Manuale)</option>
              </select>
            </div>
          </div>
          <div className="flex justify-end gap-3 pt-4 border-t border-slate-200">
            {task && (
              <button
                type="button"
                onClick={() => onComplete(task)}
                className="flex-1 bg-emerald-600 text-white py-2 rounded-lg font-bold hover:bg-emerald-700 shadow flex justify-center items-center gap-2 text-sm"
                data-testid="recurring-execute-btn"
              >
                <CheckCircle2 size={18} /> ESEGUI (Aggiorna Data)
              </button>
            )}
            <button
              type="submit"
              className="px-6 py-2 bg-blue-700 text-white rounded-lg font-semibold hover:bg-blue-800 shadow text-sm"
              data-testid="recurring-save-btn"
            >
              Salva
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
